// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeople,
        year: action.year
      };
    },
    MOST_CREATIVE_PEOPLE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeople.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
